import { CSSProperties, ReactNode } from "react";
import { Icon } from "../Icon";
import styles from "./StatusText.module.scss";

type SuccessVariant = {
  success: boolean;
  fail?: never;
  warning?: never;
};
type FailVariant = {
  fail: boolean;
  success?: never;
  warning?: never;
};
type WarningVariant = {
  warning: boolean;
  success?: never;
  fail?: never;
};
type InfoVariant = {
  success?: never;
  fail?: never;
  warning?: never;
};
type Statuses = SuccessVariant | FailVariant | WarningVariant | InfoVariant;

type StatusTextProps = Statuses & {
  dark?: boolean;
  text: ReactNode;
  style?: CSSProperties;
};

export function StatusText({
  success,
  fail,
  warning,
  dark,
  text,
  style,
}: StatusTextProps) {
  return (
    <div
      className={`${styles.statusText} ${dark ? styles.dark : ""}`}
      style={style}
    >
      {success ? (
        <Icon className={styles.successIcon} name="check_circle" />
      ) : fail ? (
        <Icon className={styles.errorIcon} name="emergency" />
      ) : warning ? (
        <Icon className={styles.warningIcon} name="warning" />
      ) : (
        <Icon className={styles.infoIcon} name="info" />
      )}
      <p
        className={`${success ? styles.success : ""} ${fail ? styles.fail : ""}`}
      >
        {text}
      </p>
    </div>
  );
}
